import React, { useEffect, useState } from 'react'
import { order_history } from '../services/api';
import { errorMsg } from '../../../helper/helpers';
import ScmModuleStyle from '../styles/scm.module.css';
import Button from '../../common/Button';
import BidsFromSupplier from './BidsFromSupplier';
import CompletedCancelledOrders from './CompletedCancelledOrders';

const PlaceOrders = ({ simObj, setSimObj, formatNum, setError, toggleSimulation, setToggleSimulation, isRequestLoading, isUtilizedActive, getMonth, scmPopup, setScmPopup,isOverlay }) => {
    const [investmentOptions, setInvestmentOptions] = useState([]);
    const [isNoData, setIsNoData] = useState(false);
    const changeTabs = (e) => {
        // if (document.querySelector(".popup-container ui.stackable.two.column.grid") == null) {
            // debugger;
        const tabs = document.getElementById(`placeOrder`).querySelectorAll(`[role="tab"]`);
        tabs.forEach((tab) => {
            tab.setAttribute("tabindex", "-1");
        });

        const target = e.currentTarget;
        const parent = target.parentNode;
        let grandparent = parent.parentNode;
        if (window.$(e.target).closest('.ui.stackable.two.column')[0] != undefined) {
            grandparent = window.$(e.target).closest('.ui.stackable.two.column')[0];
        }

        // Remove all current selected tabs
        parent
            .querySelectorAll('[aria-selected="true"]')
            .forEach((t) => {
                t.setAttribute("aria-selected", false);
                t.classList.remove(`${ScmModuleStyle["active"]}`);
                t.classList.remove(`active`);
            });

        // Set this tab as selected
        target.setAttribute("aria-selected", true);
        target.style.color = "black";
        target.setAttribute("tabindex", "0");
        target.classList.add(`${ScmModuleStyle["active"]}`);
        target.classList.add(`active`);

        // Hide all tab panels
        if (grandparent.classList.contains("stackable")) {
            grandparent.querySelectorAll('[role="tabpanel"]')
                .forEach((p) => {
                    p.setAttribute("hidden", true);
                    p.classList.remove(`active`);
                });
        }
        else {
            grandparent.querySelectorAll(`#_panelList div[role="tabpanel"]`)
                .forEach((p) => {
                    p.setAttribute("hidden", true);
                    p.classList.remove(`active`);
                });
        }
        // Show the selected panel
        let targetId = target.getAttribute("aria-controls");
        if (document.getElementById(targetId) != null) {
            document
                .getElementById(targetId)
                .removeAttribute("hidden");
            document
                .getElementById(targetId).classList.add(`active`)
        }
        setTimeout(() => {
            if (document.getElementById(targetId) != null && !isOverlay) {
                document.getElementById(targetId).tabIndex = 0;
                document.getElementById(targetId).focus();
            }
        }, 1000);
        // }
        e.stopPropagation();
    }
    const handleTabs = () => { 
        // debugger;
        const tabs = document.getElementById(`placeOrder`).querySelectorAll(`[role="tab"]`);
        const tabList = document.getElementById(`placeOrder`).querySelector(`[role="tablist"]`);

        // Add a click event handler to each tab
        tabs.forEach((tab) => {
            tab.addEventListener("click", (e) => {
                changeTabs(e);
                const tabs = document.querySelectorAll('#panel_2 [role="tab"]');
                let activeTab = window.$(e.target).closest('.item.tab-item')[0];
                tabs.forEach((tab) => {
                    tab.setAttribute("tabindex", "-1");
                });
                setTimeout(() => {
                    activeTab.setAttribute("tabindex", "0");
                    tabFocus = Array.from(tabs).indexOf(activeTab);
                }, 0)
            });
            tab.addEventListener("keydown", (e) => {
                if (e.key == "Enter") {
                    changeTabs(e);
                }
            });
        });

        // Enable arrow navigation between tabs in the tab list
        let tabFocus = 0;

        if (tabList != null) {
            tabList.addEventListener("keydown", (e) => {
                // Move right
                const tabs = document.getElementById(`panel_2`).querySelectorAll(`[role="tab"]`);
                if ((e.shiftKey && e.key === 'Tab') || (e.key == "Tab")) {
                    let activeTab = document.getElementById(`panel_2`).querySelector(`[role="tab"].active`)
                    tabs.forEach((tab) => {
                        tab.setAttribute("tabindex", "-1");
                    });
                    setTimeout(() => {
                        activeTab.setAttribute("tabindex", "0");
                        tabFocus = Array.from(tabs).indexOf(activeTab);
                    }, 100)
                }
                if (e.key === "ArrowRight" || e.key === "ArrowLeft" || e.key === "ArrowUp" || e.key === "ArrowDown" || e.key === 'Home' || e.key === 'End') {
                    tabs[tabFocus].setAttribute("tabindex", -1);
                    if (e.key === "ArrowRight" || e.key === "ArrowDown") {
                        tabFocus++;
                        // If we're at the end, go to the start
                        if (tabFocus >= tabs.length) {
                            tabFocus = 0;
                        }
                        // Move left
                    } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
                        tabFocus--;
                        // If we're at the start, move to the end
                        if (tabFocus < 0) {
                            tabFocus = tabs.length - 1;
                        }
                    }
                    else if (e.key === "Home") {
                        tabFocus = 0;
                    }
                    else if (e.key === "End") {
                        tabFocus = tabs.length - 1;
                    }
                    e.preventDefault();
                    tabs[tabFocus].setAttribute("tabindex", 0);
                    tabs[tabFocus].focus();
                }
            });
        }

        // tabs[0].click();
    }

    useEffect(() => {
        handleTabs();
        if (document.querySelector("#panel_2 .tab-item")) {
            document.querySelector("#panel_2 .tab-item").click();
        }
    }, [investmentOptions])

    useEffect(()=>{
        scmPopup?.bidsFromsupplier && window.$(`.${ScmModuleStyle['place-order']} .${ScmModuleStyle['place-order-main']} .order-tabs button:first`).click();
    },[scmPopup?.bidsFromsupplier])

    return (
        <div id='placeOrder' className={`${ScmModuleStyle['place-order']}`}>
            <div className={`${ScmModuleStyle['place-order-main']}`} id='placeOrderMain'>
                <div role="tablist" aria-label="Order tabs" className={`order-tabs ${ScmModuleStyle['order-tabs']}`}>
                    <button
                        className={`item tab-item ui button active ${ScmModuleStyle['ui']} ${ScmModuleStyle['button']} ${ScmModuleStyle['active']}`}
                        role="tab"
                        aria-selected="true"
                        aria-controls="_panel_1"
                        id="tab_11"
                        tabIndex="0"
                    >
                        Bids From Supplier
                    </button>
                    <button
                        className={`item tab-item ui button ${ScmModuleStyle['ui']} ${ScmModuleStyle['button']}`}
                        role="tab"
                        aria-selected="false"
                        aria-controls={`_panel_2`}
                        id="tab_21"
                        tabIndex="-1">
                        Completed / Cancelled Orders
                    </button>
                </div>
                <div id="_panelList" className={`${ScmModuleStyle['panel-list']}`}>
                    <div id='_panel_1' className={`${ScmModuleStyle['_panel_1_']}`} role="tabpanel" tabIndex="0" aria-labelledby="tab_11" >
                        <BidsFromSupplier  simObj={simObj} setSimObj={setSimObj} setError={setError} getMonth={getMonth} toggleSimulation={toggleSimulation} setToggleSimulation={setToggleSimulation} scmPopup={scmPopup} setScmPopup={setScmPopup} />
                    </div>
                    <div id="_panel_2" role="tabpanel" className={`${ScmModuleStyle['panel-2_']}`} tabIndex="0" aria-labelledby="tab_21" hidden>
                        <CompletedCancelledOrders simObj={simObj} setSimObj={setSimObj} setError={setError}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PlaceOrders
